import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { ValoreRuoli, useAggregatedState } from '../../../helpers';

export const UfficiContext = React.createContext(null);

const { Provider } = UfficiContext;

export const UfficiProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const { user, fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        uffici: null,
        ufficiNonConvalidati: null,
        tipiUffici: null,

        tipiUfficiFilter: [],
    });

    const { uffici } = state;

    const [isLoadingUffici, setIsLoadingUffici] = useState(false);
    const getUfficiAsync = async (pageIndex = 0, pageSize = 100, term, notConvalidato = null, valid = false, notValid = false, tipiUfficiFilter = null) => {
        try {
            setIsLoadingUffici(true);
            valid = (valid && notValid) || (!valid && !notValid) ? null : valid ? true : false;
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUffici(), {
                method: HttpMethods.POST,
                body: JSON.stringify({ pageIndex, pageSize, term, notConvalidato, valid, tipiIds: tipiUfficiFilter }),
            });
            const list = await r.json();
            list.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
                if (x.comune) {
                    x.comune.dataIstituzione = new Date(x.comune.dataIstituzione);
                    x.comune.dataCessazione = x.comune.dataCessazione ? new Date(x.comune.dataCessazione) : null;
                    if (x.comune.provincia) {
                        x.comune.provincia.inizioValidita = new Date(x.comune.provincia.inizioValidita);
                        x.comune.provincia.fineValidita = x.comune.provincia.fineValidita ? new Date(x.comune.provincia.fineValidita) : null;
                        if (x.comune.provincia.regione) {
                            x.comune.provincia.regione.inizioValidita = new Date(x.comune.provincia.regione.inizioValidita);
                            x.comune.provincia.regione.fineValidita = x.comune.provincia.regione.fineValidita ? new Date(x.comune.provincia.regione.fineValidita) : null;
                        }
                    }
                }
            })
            setState({ uffici: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUffici(false);
        }
    }

    const [isDeletingUfficio, setIsDeletingUfficio] = useState(false);
    const deleteUfficioAsync = async (ufficioId,) => {
        try {
            setIsDeletingUfficio(true);
            if (window.confirm("Confermare la disabilitazione dell'ufficio?")) {

                const r = await fetchAuthorized(ApiRoutes.Ufficio.DeleteUfficio({ ufficioId }), {
                    method: HttpMethods.DELETE
                });
                const list = uffici.result;
                list.forEach(x => {
                    if (x.id == ufficioId)
                        x.fineValidita = new Date();
                });
                setState({
                    uffici: {
                        ...uffici, result: list
                    }
                });
                showSuccessMessage(`Ufficio con id ${ufficioId} disabilitato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingUfficio(false);
        }
    }

    const [isLoadingUfficiNonConvalidati, setIsLoadingUfficiNonConvalidati] = useState(false);
    const getUfficiNonConvalidatiAsync = async (pageIndex = 0, pageSize = 10, convalidato = false) => {
        try {
            setIsLoadingUfficiNonConvalidati(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUffici(), {
                method: HttpMethods.POST,
                body: JSON.stringify({ pageIndex, pageSize, convalidato, tipiIds: user.ruolo.valoreRuolo == ValoreRuoli.Redattore ? user.utenteTipiUffici : null }),
            });
            const list = await r.json();
            setState({ ufficiNonConvalidati: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiNonConvalidati(false);
        }
    }

    const [isLoadingTipiUffici, setIsLoadingTipiUffici] = useState(false);
    const getTipiUfficiAsync = async (pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingTipiUffici(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, inizioValidita: new Date(e.inizioValidita), fineValidita: e.fineValidita ? new Date(e.fineValidita) : null, } });
            setState({ tipiUffici: list, tipiUfficiFilter: list.result.map(x => x.id) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiUffici(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingUffici,
            getUfficiAsync,

            isDeletingUfficio,
            deleteUfficioAsync,

            isLoadingUfficiNonConvalidati,
            getUfficiNonConvalidatiAsync,

            isLoadingTipiUffici,
            getTipiUfficiAsync,
        }}>
            {props.children}
        </Provider>
    );
}